/* tslint:disable */
/* eslint-disable */
/**
 * POK
 * Opis api POK
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CreateEodLogDto
 */
export interface CreateEodLogDto {
    /**
     * 
     * @type {number}
     * @memberof CreateEodLogDto
     */
    documentId?: number | null;
    /**
     * 
     * @type {Date}
     * @memberof CreateEodLogDto
     */
    date: Date;
    /**
     * 
     * @type {string}
     * @memberof CreateEodLogDto
     */
    type: string;
    /**
     * 
     * @type {string}
     * @memberof CreateEodLogDto
     */
    user?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateEodLogDto
     */
    eventName: string;
    /**
     * 
     * @type {string}
     * @memberof CreateEodLogDto
     */
    details?: string | null;
}

/**
 * Check if a given object implements the CreateEodLogDto interface.
 */
export function instanceOfCreateEodLogDto(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "date" in value;
    isInstance = isInstance && "type" in value;
    isInstance = isInstance && "eventName" in value;

    return isInstance;
}

export function CreateEodLogDtoFromJSON(json: any): CreateEodLogDto {
    return CreateEodLogDtoFromJSONTyped(json, false);
}

export function CreateEodLogDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateEodLogDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'documentId': !exists(json, 'documentId') ? undefined : json['documentId'],
        'date': (new Date(json['date'])),
        'type': json['type'],
        'user': !exists(json, 'user') ? undefined : json['user'],
        'eventName': json['eventName'],
        'details': !exists(json, 'details') ? undefined : json['details'],
    };
}

export function CreateEodLogDtoToJSON(value?: CreateEodLogDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'documentId': value.documentId,
        'date': (value.date.toISOString()),
        'type': value.type,
        'user': value.user,
        'eventName': value.eventName,
        'details': value.details,
    };
}

